import * as Yup from 'yup';

import { CardType, CardTitle } from 'types';
import { validateCheckoutAmount } from 'utils/validation';

import { FormValues } from './types';

export const initialValues: FormValues = {
  amount: '',
  last4CC: '',
  cardType: '',
  proccessingFee: '',
  paymentAuthNumber: '',
};

export const getValidationSchema = (amount: number) =>
  Yup.object().shape({
    cardType: Yup.string().required(),
    amount: validateCheckoutAmount(amount),
    proccessingFee: Yup.number().required(),
    paymentAuthNumber: Yup.string().required(),
    last4CC: Yup.string().required().length(4),
  });

export const cartTypeOptions = Object.values(CardType).map((value) => ({
  value,
  label: CardTitle[value],
}));
